<template>
  <div class="about-vadim-interviews">
    <div class="belarussian-and-international-press">
      <div class="text-block">
        <p>
          Уникальное миниатюрное кольцо с бриллиантом, созданное Вадимом
          Качаном, заинтересовало целый ряд отечественных и зарубежных
          СМИ, включая:
        </p>
        <ul>
          <li>
            <a href="https://www.belta.by/regions/view/reportazh-juvelir-iz-bresta-sozdal-samoe-malenkoe-koltso-v-mire-377219-2020/"
               target="_blank"
               rel="noopener noreferrer">БЕЛТА</a>
          </li>
          <li>
            Белорусский портал
            <a href="https://news.tut.by/society/669404.html"
               target="_blank"
               rel="noopener noreferrer">tut.by</a>
          </li>
          <li>
            Телеканалы
            <a href="https://youtu.be/9cK7N_OjGw8"
               target="_blank"
               rel="noopener noreferrer">Беларусь-2</a> и
            <a href="https://youtu.be/5kuVHr73k2w"
               target="_blank"
               rel="noopener noreferrer">Беларусь-4</a> (
            <a href="https://youtu.be/o2FRYVr7ZrY"
               target="_blank"
               rel="noopener noreferrer">cюжет в программе "Утренний эспрессо"</a>,
            <a href="https://youtu.be/dlJKiYAXkus"
               target="_blank"
               rel="noopener noreferrer">новостной сюжет</a> )
          </li>
          <li>
            Онлайн-журнал
            <a href="https://jewellerycut.com/is-this-the-smallest-diamond-ring-in-the-world"
               target="_blank"
               rel="noopener noreferrer">The Jewellery Cut</a> (Великобритания)
          </li>
          <li>
            Журнал
            <a href="https://www.luxuriousmagazine.com/worlds-smallest-diamond-ring"
               target="_blank"
               rel="noopener noreferrer">Luxurious Magazine</a> (Великобритания)
          </li>
          <li>И многие другие СМИ</li>
        </ul>
      </div>
    </div>
    <div class="video-carousel">
      <sg-vue-slick-carousel
        v-bind:adaptiveHeight="false"
        v-bind:infinite="false"
        v-on:before-change="pauseVideoBeforeChange"
      >
        <video-centered
          v-for="(videoId, i) in vadimInterviewsYouTubeIds"
          v-bind:key="videoId"
          v-bind:video-id="videoId"
          v-bind:ref="`vadim-interview-${i}`"
        ></video-centered>
      </sg-vue-slick-carousel>
    </div>
    <div class="russian-press">
      <div class="text-block">
        <p>
          Также информация об этом уникальном ювелирном изделии была
          опубликована на
          <a href="http://www.probpalata.ru/rgpp/news/index.php?ELEMENT_ID=5157&sphrase_id=1370247"
             target="_blank"
             rel="noopener noreferrer">официальном сайте</a>
          Российской государственной пробирной палаты при Министерстве
          финансов Российской Федерации.
        </p>
      </div>
    </div>
    <about-team-image-carousel
      v-bind:images="smallestRingNewspaperImages"
    ></about-team-image-carousel>
  </div>
</template>

<script>
import SgVueSlickCarousel from './utils/SgVueSlickCarousel'
import VideoCentered from './utils/VideoCentered'
import AboutTeamImageCarousel from './about-team/AboutTeamImageCarousel'

export default {
  name: 'AboutTeamVadimInterviews',
  props: ['smallest-ring-newspaper-images'],
  components: {SgVueSlickCarousel, VideoCentered, AboutTeamImageCarousel},
  data: function () {
    return {
      vadimInterviewsYouTubeIds: [
        '9cK7N_OjGw8', '5kuVHr73k2w', 'o2FRYVr7ZrY', 'dlJKiYAXkus']
    }
  },
  methods: {
    pauseVideoBeforeChange: function (oldSlideIndex, newSlideIndex) {
      let oldSlideVideo = this.$refs[`vadim-interview-${oldSlideIndex}`]
      oldSlideVideo[0].player.stopVideo()
    }
  }
}
</script>

<style scoped lang="scss">
  .about-vadim-interviews {
    background-color: $default-background-color;
    @include media (">desktop") { padding-top: 3em; }
    @include media ("<=desktop") { padding-top: 2em; }
    padding-bottom: 3em;
    & > * {
      margin-bottom: 2em !important;
      &:last-child { margin-bottom: 0 !important; }
    }
    & > .video-carousel {
      @include centered-block-width($desktop: 70%, $mobile: 100%);
      @media only print { display: none;}
    }
    & > .russian-press {
      padding: 1em 0;
    }
    .text-block {
      @include text-block();
    }
    ul {
      text-align: left;
      padding-left: 1.5em;
      list-style-type: disc;
      li { display: list-item; }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/AboutTeamVadimInterviews.vue